var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { BaseSingletonService, Singleton } from '~/services/service.base';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { MobxQuery } from '~/tools/mobx.query';
import { api } from '~/tools/api';
import { EApiUrl } from '~/tools/api/types';
import { plainToInstance } from 'class-transformer';
import { ModelBookContentDocument, ModelBookContentSection } from '~/models';
import { ServiceConfig } from '~/services/service.config';
export let ServiceBookContent = class ServiceBookContent extends BaseSingletonService {
    configService;
    documents = observable.array([]);
    sections = observable.array([]);
    constructor(configService) {
        super();
        this.configService = configService;
        makeObservable(this);
    }
    clearData() {
        this.documents.replace([]);
        this.sections.replace([]);
    }
    getBookContent(communityId, bookId, sheetId, lang = this.configService.lang) {
        return new MobxQuery({
            queryFn: (() => api
                .get(`${EApiUrl.sheets}/${sheetId}/${EApiUrl.content}`, {
                params: {
                    bookId,
                    lang,
                    communityId,
                    sheetId,
                },
            })
                .then(response => {
                runInAction(() => {
                    this.documents.replace(plainToInstance(ModelBookContentDocument, response.data.documents));
                    this.sections.replace(plainToInstance(ModelBookContentSection, response.data.sections));
                });
            })),
        }).query();
    }
};
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ServiceBookContent.prototype, "clearData", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String, String, Object]),
    __metadata("design:returntype", void 0)
], ServiceBookContent.prototype, "getBookContent", null);
ServiceBookContent = __decorate([
    Singleton(),
    __metadata("design:paramtypes", [typeof (_a = typeof ServiceConfig !== "undefined" && ServiceConfig) === "function" ? _a : Object])
], ServiceBookContent);
